// extracted by mini-css-extract-plugin
export default {"loaderContainer":"VirtualGrid_loaderContainer__xW+gg"};